import { cornType } from '@eigtech/shared-corn';
export const notesServiceCorn = (eventName) => cornType('notes', eventName);
export const NotesServiceCornSchema = notesServiceCorn();
export const NoteCornSchema = notesServiceCorn('note');
export const NotebookCornSchema = notesServiceCorn('notebook');
